import * as amplitude from '@amplitude/analytics-browser';
import { VpLoader, VpToggle } from '@vtmn-play/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoles } from '../../../contexts/RolesContext';
import { useToast } from '../../../contexts/ToastContext';
import { usePatchSportNatureStatus } from '../../../hooks/mutations/usePatchSportNatureStatus';

export type ArchiRowEnableProps = {
  toggleStatus: boolean;
  productNatureId: number;
  updateArchitectureData: (productNatureId: number, isEnabled: boolean) => void;
};
export const ArchiRowEnable = ({
  toggleStatus,
  productNatureId,
  updateArchitectureData,
}: ArchiRowEnableProps) => {
  const { t } = useTranslation();
  const { addToast } = useToast();
  const { hasRoleSportLeader } = useRoles();

  const [isProductNatureEnabled, setIsProductNatureEnabled] =
    useState(toggleStatus);

  const params = new URLSearchParams(document.location.search);
  const sportId = params.get('sportId') || '';

  const mutationSuccess = () => {
    addToast(
      t('architecture.update-product.success'),
      'success',
      4500,
      'archi-row-enable-success',
    );
    setIsProductNatureEnabled(!isProductNatureEnabled);
    updateArchitectureData(productNatureId, !isProductNatureEnabled);
  };

  const mutationError = () => {
    addToast(
      t('architecture.update-product.error'),
      'danger',
      4500,
      'archi-row-enable-error',
    );
  };

  const { mutate, isPending } = usePatchSportNatureStatus(
    sportId,
    productNatureId,
    !isProductNatureEnabled,
    mutationSuccess,
    mutationError,
  );

  return isPending ? (
    <VpLoader size="small" data-testid="archi-row-enable-loader" />
  ) : (
    <div data-testid="archi-row-enable" className="archi-row-enable">
      <VpToggle
        size="small"
        data-testid="archi-row-enable-toggle"
        defaultChecked={isProductNatureEnabled}
        onChange={() => {
          mutate();
          amplitude.track('Architecture_Toggle-Nature-Enablement', {
            natureId: productNatureId,
          });
        }}
        disabled={!hasRoleSportLeader}
      />
    </div>
  );
};
